// import $store from '@/store'
import { formatMoneyAmount } from '@/lib/formattingUtils'
import { SeasonRanking } from '@/model/ranking/Season'
import { FinishedTournament } from '@/model/ranking/FinishedTournament'
import { TournamentRanking } from '@/model/ranking/TournamentRankings'
import { SeasonRankingState, TicketGroup } from '@/store/modules/ranking/season'
import season from '@/store/modules/ranking/season'
import tournament, { TournamentRankingState } from '@/store/modules/ranking/tournament'
import zoneHistory, { ZoneHistoryState } from '@/store/modules/ranking/zoneHistory'

export interface RankingState {
  season: SeasonRankingState
  tournament: TournamentRankingState
  zoneHistory: ZoneHistoryState
}

const state = {}
const getters = {}
const actions = {}
const mutations = {}

/**
 * Sort given array of QualifiedUser by score amount and return a slice of it
 * @param list
 * @param from - Index to start slicing
 * @param to - End position of the slice to be returned
 */
export function sliceAndSortRankings(
  list: Array<SeasonRanking | TournamentRanking | TicketGroup | FinishedTournament>,
  from: number,
  to?: number,
  func?: any
): Array<SeasonRanking | TournamentRanking | TicketGroup | FinishedTournament> {
  return list.length > 0 ? list.sort(func).slice(from, to) : []
}

/**
 * Formatting total winnings for a given array
 * @param rankings
 */
export function formatWinnings(
  rankings: Array<TournamentRanking | FinishedTournament>,
  currency = 'EUR'
): Array<TournamentRanking | FinishedTournament> {
  return rankings.map((ranking) => ({
    ...ranking,
    totalWin: parseFloat(ranking.totalWin) > 0 ? formatMoneyAmount(ranking.totalWin, currency) : '-',
  }))
}

/**
 * Sorting functions
 */
export const sortUsersByRank = (a: SeasonRanking, b: SeasonRanking) => {
  if (a.seasonRank === 0) {
    return 1
  }
  if (b.seasonRank === 0) {
    return -1
  }
  if (a.seasonRank < b.seasonRank) {
    return -1
  } else if (a.seasonRank > b.seasonRank) {
    return 1
  }
  return 0
}
export const sortTournamentsById = (a: TicketGroup, b: TicketGroup) =>
  b.seasonRankings[0].ticketInfo.tournamentId < a.seasonRankings[0].ticketInfo.tournamentId ? 1 : -1

/**
 * This structure enables use of nested namespaced modules, e.g. $store.getters['ranking/tournament/rankings']()
 */
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  modules: {
    season,
    tournament,
    zoneHistory,
  },
}
